import { render, staticRenderFns } from "./amazon-ads.vue?vue&type=template&id=3f9ee1c8"
import script from "./amazon-ads.vue?vue&type=script&lang=js"
export * from "./amazon-ads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports